export default __webpack_public_path__ + "static/media/otp.24b441aa.png";